module.exports = __webpack_public_path__ + "img/wechat-sunwen.9bc2e88b.jpg";